import { render, staticRenderFns } from "./ServiceNoveltyForm.vue?vue&type=template&id=1dc6c58b"
import script from "./ServiceNoveltyForm.vue?vue&type=script&lang=js"
export * from "./ServiceNoveltyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports